var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.54163C8.94772 7.54163 9.71875 6.77059 9.71875 5.82288C9.71875 4.87516 8.94772 4.10413 8 4.10413C7.05228 4.10413 6.28125 4.87516 6.28125 5.82288C6.28125 6.77059 7.05228 7.54163 8 7.54163ZM8 5.24996C8.31591 5.24996 8.57292 5.50697 8.57292 5.82288C8.57292 6.13878 8.31591 6.39579 8 6.39579C7.68409 6.39579 7.42708 6.13878 7.42708 5.82288C7.42708 5.50697 7.68409 5.24996 8 5.24996Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 5.82288C13.1562 2.97972 10.8432 0.666626 8 0.666626C5.15684 0.666626 2.84375 2.97972 2.84375 5.82288C2.84375 6.94765 3.19959 8.0166 3.87282 8.91416L6.62448 12.5827C6.9477 13.0136 7.46192 13.2708 8 13.2708C8.53808 13.2708 9.05231 13.0136 9.37554 12.5827L12.1272 8.91416C12.8004 8.0166 13.1562 6.94765 13.1562 5.82288ZM11.2105 8.2266L8.45893 11.8951C8.34934 12.0412 8.18207 12.125 8 12.125C7.81793 12.125 7.65066 12.0412 7.54109 11.8952L4.78946 8.2266C4.26619 7.52896 3.98958 6.69775 3.98958 5.82288C3.98958 3.61153 5.78866 1.81246 8 1.81246C10.2113 1.81246 12.0104 3.61153 12.0104 5.82288C12.0104 6.69775 11.7338 7.52896 11.2105 8.2266Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8639 14.7604C10.8639 14.444 10.6074 14.1875 10.291 14.1875H5.70768C5.39126 14.1875 5.13477 14.444 5.13477 14.7604C5.13477 15.0768 5.39126 15.3333 5.70768 15.3333H10.291C10.6074 15.3333 10.8639 15.0768 10.8639 14.7604Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.988d6790f9885f815f6d7eb0a09d2b80.svg";
export { ForwardRef as ReactComponent };